import { ObservableItemIdentifier } from '../../../api-contracts/other/ObservableItemIdentifier';
import { ObservableLevelsEnum } from '../../../data/enums';
import { flattenObjectStrings } from '../../../utils/flattenObjectString';

class TocUndercarriageScreenPath {
  partName: string;
  categoryName: string;
  optionalPaths: string[];
  requiredPaths: string[];
  anyPaths: string[];
  anyPathStartsWith: string[];
  level?: ObservableLevelsEnum;

  constructor({
    partName,
    categoryName,
    optionalPaths,
    requiredPaths,
    anyPaths = [],
    anyPathStartsWith = [],
    level = ObservableLevelsEnum.equipmentPart,
  }: {
    partName: string;
    categoryName: string;
    optionalPaths: string[];
    requiredPaths: string[];
    anyPaths?: string[];
    anyPathStartsWith?: string[];
    level?: ObservableLevelsEnum;
  }) {
    this.partName = partName;
    this.categoryName = categoryName;
    this.optionalPaths = optionalPaths;
    this.requiredPaths = requiredPaths;
    this.anyPaths = anyPaths;
    this.anyPathStartsWith = anyPathStartsWith;
    this.level = level;
  }
}
export const tocUndercarriageScreenPathValues: TocUndercarriageScreenPath[] = [
  new TocUndercarriageScreenPath({
    partName: 'Side Frame',
    categoryName: '',
    level: ObservableLevelsEnum.equipment,
    anyPaths: [
      ObservableItemIdentifier.Identifiers.Undercarriage.SideFrame.Photo,
      ObservableItemIdentifier.Identifiers.Undercarriage.SideFrame.Comments,
    ],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Roller Path',
    categoryName: 'Shoes',
    anyPaths: [
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath.Wear
        .Measurement,
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath
        .WearIndicators.Toenailing.Checked,
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath
        .WearIndicators.SpallingDelaminationMinorCracking.Checked,
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath
        .WearIndicators.SevereCracking.Checked,
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath.Photo,
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath.Comments,
    ],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Pitch Extension',
    categoryName: 'Shoes',
    anyPathStartsWith: ['Undercarriage.Shoes.PitchExtension.'],
    anyPaths: [],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Drive Lug',
    categoryName: 'Shoes',
    anyPathStartsWith: [],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.DriveLug,
    ),
    // anyPathStartsWith: [
    //   'Undercarriage.DriveLug.',
    //   'Undercarriage.Shoes.DriveLug.',
    // ],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Roller Path',
    categoryName: 'Drive Tumbler',
    // anyPathStartsWith: ['Undercarriage.RollerPath.'],
    anyPathStartsWith: [],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.RollerPath,
    ),
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Drive Lug',
    categoryName: 'Drive Tumbler',
    // anyPathStartsWith: ['Undercarriage.DriveLug.'],
    anyPathStartsWith: [],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.DriveLug,
    ),
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Tumbler Engagement',
    categoryName: 'Drive Tumbler',
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.TumblerEngagement,
    ),
    // anyPathStartsWith: ['Undercarriage.TumblerEngagement.'],
    anyPathStartsWith: [],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Front Idler',
    categoryName: 'Idler',
    // anyPathStartsWith: [
    //   'Undercarriage.Idler.Front.',
    //   'Undercarriage.Idler.WearIndicators.',
    // ],
    anyPathStartsWith: [],
    anyPaths: [
      ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Rear
        .VisualCondition,
      ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Photo,
      ...flattenObjectStrings(
        ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Front,
      ),
      ...flattenObjectStrings(
        ObservableItemIdentifier.Identifiers.Undercarriage.Idler.WearIndicators,
      ),
    ],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Rear Idler',
    categoryName: 'Idler',
    // anyPathStartsWith: [
    //   'Undercarriage.Idler.Rear.',
    //   'Undercarriage.Idler.WearIndicators.',
    // ],
    anyPathStartsWith: [],
    anyPaths: [
      ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Photo,
      ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Comments,
      ...flattenObjectStrings(
        ObservableItemIdentifier.Identifiers.Undercarriage.Idler.Rear,
      ),
      ...flattenObjectStrings(
        ObservableItemIdentifier.Identifiers.Undercarriage.Idler.WearIndicators,
      ),
    ],
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Load Roller',
    categoryName: 'Roller',
    optionalPaths: [],
    // anyPathStartsWith: ['Undercarriage.Roller.'],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.Roller,
    ),
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Return Roller',
    categoryName: 'Roller',
    // anyPathStartsWith: ['Undercarriage.Roller.'],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.Roller,
    ),
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Slider',
    categoryName: 'Slider',
    // anyPathStartsWith: ['Undercarriage.Roller.'],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.Roller,
    ),
    optionalPaths: [],
    requiredPaths: [],
  }),
  new TocUndercarriageScreenPath({
    partName: 'Side Frame',
    categoryName: '',
    // anyPathStartsWith: ['Undercarriage.SideFrame.'],
    anyPaths: flattenObjectStrings(
      ObservableItemIdentifier.Identifiers.Undercarriage.SideFrame,
    ),
    optionalPaths: [],
    requiredPaths: [],
    level: ObservableLevelsEnum.equipment,
  }),
];
